(function () {
  if (window.mzTiersInit) return;
  window.mzTiersInit = true;
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
  var fmt;
  try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }); } catch (e) { fmt = null; }
  function money(c) { return fmt ? fmt.format(c / 100) : '$' + (c / 100).toFixed(2); }

  function setup(w) {
    if (w.dataset.ready) return;
    w.dataset.ready = '1';
    var scope = w.closest('product-info') || w.closest('.product') || document;
    function qtyEl() { return scope.querySelector('input[name="quantity"]'); }
    var opts = [].slice.call(w.querySelectorAll('.mzt__opt'));
    var note = w.querySelector('[data-mzt-note]');
    var prices = {};
    try { prices = JSON.parse(w.querySelector('[data-mzt-prices]').textContent); } catch (e) {}
    var price = +w.dataset.price;

    function inCart() { return +w.dataset.inCart || 0; }
    function q() { var e = qtyEl(); return Math.max(1, parseInt(e && e.value, 10) || 1); }

    function paintPrices() {
      opts.forEach(function (o) {
        var each = price - Math.floor(price * +o.dataset.pct / 100);
        o.querySelector('[data-mzt-each]').textContent = money(each);
      });
    }

    function tierFor(n) { var on = opts[0]; opts.forEach(function (o) { if (n >= +o.dataset.min) on = o; }); return on; }
    function perProduct() { return w.dataset.scope === 'product'; }

    function sync() {
      var add = q(), have = inCart(), on = tierFor(add);
      opts.forEach(function (o) { o.setAttribute('aria-checked', o === on ? 'true' : 'false'); });
      var msg = '';
      if (have > 0) {
        var got = tierFor(add + have), pct = +got.dataset.pct;
        msg = 'You already have ' + have + (perProduct() ? ' of these' : '') + ' in your cart, so ' + (add + have) + ' in total' +
          (pct ? ' gets ' + pct + '% off.' : '.');
        var nx = opts[opts.indexOf(got) + 1];
        if (nx) msg += ' Add ' + (+nx.dataset.min - add - have) + ' more to save ' + nx.dataset.pct + '%.';
      } else {
        var next = opts[opts.indexOf(on) + 1];
        if (next) msg = 'Add ' + (+next.dataset.min - add) + ' more' + (perProduct() ? '' : ' (any mix)') + ' to save ' + next.dataset.pct + '%.';
      }
      note.textContent = msg;
      note.hidden = !msg;
    }

    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        var qty = qtyEl();
        if (!qty) return;
        qty.value = +o.dataset.min;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
    });
    scope.addEventListener('input', function (e) { if (e.target.name === 'quantity') sync(); });
    scope.addEventListener('change', function (e) { if (e.target.name === 'quantity') sync(); });
    scope.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('quantity-input')) setTimeout(sync, 0); });

    function onVariant(id) {
      if (id && prices[id] != null) { price = prices[id]; paintPrices(); }
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) { var v = e && e.data && e.data.variant; if (v) onVariant(v.id); setTimeout(sync, 0); });
    }
    scope.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects')) [300, 900].forEach(function (t) { setTimeout(function () {
        var f = scope.querySelector('form[action*="/cart/add"] [name="id"]');
        var u = new URLSearchParams(location.search).get('variant');
        onVariant((f && f.value) || u);
        sync();
      }, t); });
    });

    function refreshCount() {
      var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      var done = function (n) { if (String(n) === String(w.dataset.inCart)) return; w.dataset.inCart = n; var qty = qtyEl(); if (qty) qty.value = 1; sync(); };
      if (perProduct()) {
        return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          done(c.items.reduce(function (n, i) { return n + (String(i.product_id) === w.dataset.product && !(i.properties && i.properties._mz_gift) ? i.quantity : 0); }, 0));
        }).catch(function () {});
      }
      fetch(root + '?sections=mz-tiers-count', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var m = /data-mzt-count="(\d+)"/.exec(j['mz-tiers-count'] || '');
          if (m) done(m[1]);
        }).catch(function () {});
    }
    document.addEventListener('mz:cart:updated', refreshCount);
    w.mztRefresh = refreshCount;

    paintPrices();
    sync();
  }

  function all() { document.querySelectorAll('[data-mzt]').forEach(setup); }
  all();
  new MutationObserver(all).observe(document.body, { childList: true, subtree: true });
})();
